import React from 'react';
import { DateWrapper } from './style'
import { useSelector } from 'react-redux';

// Libs
import Translation from 'libs/Translation';

const DateItem = ({ 
  item: {Date, Slots}, 
  onClick,
  selected,
  borderColor
}) => {
const {webConfig} = useSelector(state => state.core);

return (
<DateWrapper 
    key={Date}
    webConfig={webConfig} 
    selected={Date === selected}
    borderColor={borderColor}
>
    <div 
        className='free-time' 
        onClick={() => onClick(Date)}
    >
        <div
            className="date text"
        >
            {Translation.dateWithoutTime(Date)}
        </div>
        <div className='text'> 
            {Slots?.length > 0 ?
            <div className="counts text">
                {Translation.t('text.free-time', {count: Translation.n(Slots?.length)})}
            </div>
            :
            <div className="no-free text">
               {Translation.t('label.no-free-times')}
            </div>
            }   
        </div>
    </div>
</DateWrapper>
)
};

export default DateItem;